import React from 'react'
import '@fortawesome/fontawesome-free/css/all.min.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import PublicRoute from './components/PublicRoute'
import { ROUTES } from './routes/routes'
import { RouteConfig } from './types/routeConfigType';
import Menu from './components/Menu';
import StatusBar from './components/Statusbar';

const App: React.FC = () => {
  //ACTIVAR EL SIGUIENTE CODIGO PARA EVITAR EL CLIC DERECHO EN LAS PANTALLAS
  // useEffect(() => {
  //   const disableContextMenu = (e: MouseEvent) => {
  //     e.preventDefault();
  //   };

  //   document.addEventListener('contextmenu', disableContextMenu);
  //   return () => {
  //     document.removeEventListener('contextmenu', disableContextMenu);
  //   }
  // }, []);

  return (
    <AuthProvider>
      <Router>
        <MainContent />
      </Router>
    </AuthProvider>
  );
};


const renderRoutes = (routes: RouteConfig[]) => {
  return routes.map(({ path, element, isProtected, children }, index) => {
    if (children) {
      return (
        <Route
          key={index}
          path={path}
          element={element || <React.Fragment />}
        >
          {renderRoutes(children)}
        </Route>
      );
    };

    return (
      <Route
        key={index}
        path={path}
        element={isProtected ? <ProtectedRoute>{element}</ProtectedRoute> : <PublicRoute>{element}</PublicRoute>}
      />
    );
  });
};

const MainContent: React.FC = () => {
  const { user } = useAuth();
  // const allRoutes = Object.values(ROUTES).flat() as RouteConfig[];
  /*  return (
     <>
       {user && <Menu />}
       <Routes>
         {allRoutes.map(({ path, element, isProtected }, index) => (
           <Route
             key={index}
             path={path}
             element={
               isProtected ? (
                 <ProtectedRoute>{element}</ProtectedRoute>
               ) : (
                 <PublicRoute>{element}</PublicRoute>
               )
             }
           />
         ))}
       </Routes>
     </>
   ); */
  return (
    <>
      {user && <Menu />}
      <Routes>{renderRoutes(Object.values(ROUTES).flat())}</Routes>
      <StatusBar />
    </>
  )
};


export default App;
